<script setup>
import { RouterView } from "vue-router";
import { onMounted, onUnmounted, ref } from "vue";
import SideBar from "@/components/layout/SideBar.vue";
import NavBar from "@/components/layout/NavBar.vue";

const collapse = ref(false);

const setCollapse = () => {
  collapse.value = !collapse.value;
};

// detect device
const isDeviceDesktop = ref(window.innerWidth >= 1024);

const handleResize = () => {
  isDeviceDesktop.value = window.innerWidth >= 1024;
};

onMounted(() => {
  window.addEventListener("resize", handleResize);
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});
</script>





<template>
  <div class="min-h-screen bg-gray-50">
    <div
      v-if="!isDeviceDesktop && !collapse"
      className="fixed inset-0 bg-black/50
    z-40 lg:hidden"
      @click="setCollapse"
    />

    <!-- main content -->
    <SideBar
      :collapsed="collapse"
      :set-collapsed="setCollapse"
      :is-device-desktop="isDeviceDesktop"
    />
    <div
      :class="isDeviceDesktop ? (collapse ? 'lg:ml-16' : 'lg:ml-64') : 'ml-0'"
    >
      <NavBar />
      <main class="p-4 lg:p-6">
        <div class="max-w-7xl mx-auto">
          <RouterView />
        </div>
      </main>
    </div>
  </div>
</template>